import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {RouterLink} from "@angular/router";
import {
  GET_ALL_ESPECIALIDADES,
  CREAR_ESPECIALIDAD,
  GET_DATA_BY_ID,
  UPDATE_DATA_WEB, LOGIN_MUTATION_MKT, DELETEDATABYID
} from "../../../graphql/graphql.queris";
import {AuthService} from "../../../auth/auth.service";
import {Apollo} from "apollo-angular";
import {FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {capturarFile, closeModal, mostrarToast, validateSizeFile} from "../../../utils/utilities";
import {DomSanitizer} from "@angular/platform-browser";
import {environment} from "../../../../environments/environment";
import {RestService} from "../../../services/rest.services.service";
import {ServiceNotificationService} from "../../../services/service-notification.service";
import {NotificationsComponent} from "../../../notifications/notifications.component";
import {BreadcrumbMktComponent} from "../breadcrumb-mkt/breadcrumb-mkt.component";
import {SucursalHorariosService} from "../sucursal-horarios/services/sucursal-horarios.service";
import bootstrap from "../../../../main.server";

@Component({
  selector: 'app-especialidades',
  standalone: true,
  imports: [
    NgForOf,
    RouterLink,
    FormsModule,
    NgIf,
    ReactiveFormsModule,
    NgOptimizedImage,
    NotificationsComponent,
    BreadcrumbMktComponent,
  ],
  templateUrl: './especialidades.component.html',
  styleUrl: './especialidades.component.css'
})
export class EspecialidadesComponent  implements OnInit{
  @ViewChild('addEspecialidad') addEspecialidad!: ElementRef;
  @ViewChild('editEspecialidades') editEspecialidades!: ElementRef;
  @ViewChild('inputImagen') inputImagen!: ElementRef;
  @ViewChild('inputIcon') inputIcon!: ElementRef;
  @ViewChild('editInputImagen') editInputImagen!: ElementRef;
  @ViewChild('editInputIcon') editInputIcon!: ElementRef;
  title: string = 'Especialidades';
  route='/dashboardmkt/especialidadesWeb'
  especialidades: any[] = [];
  formAddEspecialidad: FormGroup = new FormGroup({});
  formEditEspecialidad: FormGroup = new FormGroup({});
  especialidad: string = '';
  descripcion: string = '';
  categoria: string = '';
  imagen: string = '';
  showNavBar: boolean = false;
  previewImagen: string | ArrayBuffer | null | undefined;
  previewIcon: string | ArrayBuffer | null | undefined;
  public archivos: any = [];
  urlImage: string = '';
  imgUrl = environment.imgUrl;
  imgPreview: string = '';
  iconPreview: string = '';
  _idEspecialidad: string = '';
  datosPromocion = new FormData();
  isLoading: boolean = false;
  sucursales:any[] = [];






  constructor(
    private authService: AuthService,
    private apollo: Apollo,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private restService: RestService,
    private serviceNotifications: ServiceNotificationService,
    private sucursalHorariosService: SucursalHorariosService
  ) {
  }

  ngOnInit() {
    this.getAllEspecialidades()
    this.sucursalHorariosService.getAllDataSucursalHorario()
      .subscribe((result: any) => {
        this.sucursales =result.data.getAllDataHorarios;
      });

    this.formAddEspecialidad = this.fb.group({
      especialidad: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      categoria: ['', [Validators.required]],
      imagen: ['', [Validators.required]],
      icono: ['', [Validators.required]],
      showNavBar: [null, [Validators.required]],
      procedimientosList: ['', Validators.required],
      centrosMedicos: this.fb.array([])
    });

    this.formEditEspecialidad = this.fb.group({
      especialidad: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      categoria: ['', [Validators.required]],
      imagen: ['', [Validators.required]],
      icono: ['', [Validators.required]],
      showNavBar: [null, [Validators.required]],
      procedimientosList: ['', Validators.required],
      centrosMedicos: this.fb.array([])

    });








    this.formAddEspecialidad.get('showNavBar')?.valueChanges.subscribe(value => {
      const booleanValue = value === 'true';
      if (this.formAddEspecialidad.get('showNavBar')?.value !== booleanValue) {
        this.formAddEspecialidad.patchValue({ showNavBar: booleanValue }, { emitEvent: false });
      }
    });

    this.formEditEspecialidad.get('showNavBar')?.valueChanges.subscribe(value => {
      const booleanValue = value === 'true';
      if (this.formEditEspecialidad.get('showNavBar')?.value !== booleanValue) {
        this.formEditEspecialidad.patchValue({ showNavBar: booleanValue }, { emitEvent: false });
      }
    });

}


  getDataById(id: string) {
    this._idEspecialidad = id;
    this.centrosMedicos.clear();


    const token = this.authService.getToken();
    this.apollo.query({
      query: GET_DATA_BY_ID,
      variables: {id: id},
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'network-only'
    }).subscribe((result: any) => {
      const {categoria, descripcion, especialidad, imagen, showNavBar, icono, centrosMedicos, procedimientosList} = result.data.getDataById;
      centrosMedicos.forEach((sucursal: any) => {
        this.addSucursal(sucursal);
      });
      this.formEditEspecialidad.patchValue({
        categoria,
        descripcion,
        especialidad,
        imagen,
        icono,
        showNavBar,
        procedimientosList
      });
      this.imgPreview =  imagen;
      this.iconPreview =  icono;
    });
  }






  getAllEspecialidades() {
    const token = this.authService.getToken();
    this.apollo.query({
      query: GET_ALL_ESPECIALIDADES,
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'network-only'
    }).subscribe((result: any) => {
      this.especialidades = result.data.getAllDataWebPrivate;
    });
  }

  onSubmit() {

  }

  sendAllData() {
      try {
        this.isLoading = true;
        // console.log(this.archivos);
        this.datosPromocion = new FormData();
        this.archivos.forEach((archivo: any) => {
          this.datosPromocion.append('file', archivo);
        });
        if (this.archivos.length === 0) {
          this.mostrarToast('Por favor seleccione una imagen', false);
          this.isLoading = false
        }
        const token = this.authService.getToken();
        this.restService.post({
          url: environment.apiUploadImage,
          body: this.datosPromocion,
        })
          .subscribe((res: any) => {

            this.formAddEspecialidad.patchValue({
              imagen: res[0].path,
              icono: res[1].path
            });
            if (!this.formAddEspecialidad.valid) {
              this.mostrarToast('Por favor complete todos los campos', false);
              this.isLoading = false;
            }else{
              this.createEspecialidad(this.formAddEspecialidad.value);
              this.getAllEspecialidades();
              this.previewIcon = '';
              this.previewImagen = '';
              this.formAddEspecialidad.reset();
              this.resetdataAdd();
            }
          });

      } catch (e) {
        console.error(e);

    }
  }

  updateEspecialidadWeb(id: string) {
    if (!this.formEditEspecialidad.valid){
      this.mostrarToast('Por favor complete todos los campos', false);
    }else{
      try {
        this.isLoading = true;
        this.datosPromocion = new FormData();
        this.archivos.forEach((archivo: any) => {
          this.datosPromocion.append('file', archivo);
        });
        if(this.archivos.length > 0){
          const token = this.authService.getToken();
          try{
            this.restService.post({
              url: environment.apiUploadImage,
              body: this.datosPromocion
            }).subscribe(( res: any ) => {

              this.formEditEspecialidad.patchValue({
                imagen: res[0].path,
                icono: res[1].path
              });
              this.updateEspecialidad(this._idEspecialidad, this.formEditEspecialidad.value);
              this.getAllEspecialidades();

            });
          }catch (e) {
            console.error(e);
          }
        } else{
          console.log("No subio imagen")
          this.formEditEspecialidad.patchValue({
            imagen: this.imgPreview,
            icono: this.iconPreview
          });
          this.updateEspecialidad(this._idEspecialidad, this.formEditEspecialidad.value);
          this.getAllEspecialidades();
          this.formEditEspecialidad.reset();
          this.resetdataEdit();
        }
      } catch (e) {
        console.error(e);
        this.resetdataEdit();

      }
    }

  }

  resetdataEdit() {
    this.centrosMedicosUpdate.clear();
  }
  resetdataAdd() {
    this.centrosMedicos.clear();
  }

  updateEspecialidad(id: string, input: any) {
    this.isLoading = true;
    const token = this.authService.getToken();
    try {
      this.apollo.mutate({
        mutation: UPDATE_DATA_WEB,
        variables: {
          id: id,
          input: this.formEditEspecialidad.value
        },
        context: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      }).subscribe((result: any) => {
        this.getAllEspecialidades();
        this.isLoading = false;
        this.mostrarToast('Especialidad actualizada con exito', true);
        closeModal(this.editEspecialidades);
        this.formEditEspecialidad.reset();
        this.centrosMedicosUpdate.clear();
        this.archivos= [];
        this.previewIcon = '';
        this.previewImagen = '';
      })
    }catch (e) {
      this.mostrarToast('Ha ocurrido un error al actualizar la especialidad', false);
    }}

  createEspecialidad(input: any){
    try{
      const token = this.authService.getToken();
      this.apollo.mutate({
        mutation: CREAR_ESPECIALIDAD,
        variables: { input: input },
        context: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      }).subscribe((result: any) => {
        this.isLoading = false;
        this.mostrarToast('Especialidad creada con exito', true);
        closeModal(this.addEspecialidad);
        this.archivos = [];
        this.formAddEspecialidad.reset();
        this.getAllEspecialidades();
      })
    }catch (e) {
      this.mostrarToast('Ha ocurrido un error al crear la especialidad', false);
    }
  }

  cleanId(){
    this._idEspecialidad = '';
  }

  createSucursalForm(): FormGroup{
    return this.fb.group({
      nameSucursal: ['', [Validators.required]],
      ciudad: ['', [Validators.required]],
      direccionSucursal: ['', [Validators.required]],
      linkMaps: ['', [Validators.required]],
    });
  }

  get centrosMedicos(): FormArray {
    if (this._idEspecialidad) {
    return this.formEditEspecialidad.get('centrosMedicos') as FormArray;
    }else{
      return this.formAddEspecialidad.get('centrosMedicos') as FormArray;
    }
  }

  get centrosMedicosUpdate(): FormArray {
    return this.formEditEspecialidad.get('centrosMedicos') as FormArray;
  }

  addSucursal(sucursalData: any) {
    // console.log(sucursalData)
    const newSucursalForm = this.createSucursalForm();
    newSucursalForm.patchValue(sucursalData);

    if(this._idEspecialidad){
      console.log("Update")
      this.centrosMedicosUpdate.push(newSucursalForm);
    }else{
      console.log("Add")
      this.centrosMedicos.push(newSucursalForm);
    }
  }

  isSucursalAssigned(sucursal: any): boolean {
    if(this._idEspecialidad) {
      return this.centrosMedicosUpdate.controls.some((control) => control.get('nameSucursal')?.value === sucursal.nameSucursal);
    }else{
      return this.centrosMedicos.controls.some((control) => control.get('nameSucursal')?.value === sucursal.nameSucursal);

    }
  }


  removeSucursal(index: number) {
    if (this._idEspecialidad) {
      this.centrosMedicosUpdate.removeAt(index);
    }else{
      this.centrosMedicos.removeAt(index);
    }
  }





  capturarArchivo1(event: Event): void {
    const input = event.target as HTMLInputElement;
    let validate1;
    if (input && input.files) {
      // console.log(input.files[0].size)
      validate1 = validateSizeFile(input.files[0].size);
    }
    if (!validate1) {
      this.mostrarToast('El tamaño de la imagen no puede ser mayor a 5MB', false);
      this.previewImagen = '';
      this.inputImagen.nativeElement.value = '';
      this.editInputImagen.nativeElement.value = '';
      return;
    }
    capturarFile(event, this.sanitizer, this.archivos, (preview) => this.previewImagen = preview);

  }
  capturarArchivo2(event: Event): void {
    const input = event.target as HTMLInputElement;
    let validate2;
    if (input && input.files) {
      // console.log(input.files[0].size)
      validate2 = validateSizeFile(input.files[0].size);
    }
    if (!validate2) {
      this.mostrarToast('El tamaño de la imagen no puede ser mayor a 5MB', false);
      this.previewIcon = '';
      this.inputIcon.nativeElement.value = '';
      this.editInputIcon.nativeElement.value = '';
      return;
    }
    capturarFile(event, this.sanitizer, this.archivos, (preview)=> this.previewIcon = preview);
  }

  mostrarToast(message: string, type: boolean) {
    this.serviceNotifications.recibeNotificacion.emit({
      mensaje: message,
      tipo: type
    })
  }

  deleteByID(_id: any) {
    const token = this.authService.getToken();
    this.apollo.mutate({
      mutation: DELETEDATABYID,
      variables: {id: _id},
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    }).subscribe((result: any) => {
      this.getAllEspecialidades();
      this.mostrarToast('Especialidad eliminada con exito', true);
    });

  }
}
